import React from 'react';
import ColorMastersContext from './color-masters-context';
import { fetchColorMasters } from './color-masters-api';

export default function ColorMastersProvider({children}) {
  const state = {
    fetchColorMasters
  };

  return (
    <ColorMastersContext.Provider value={state}>
      {children}
    </ColorMastersContext.Provider>
  )
};
